export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook("vue:error", (error) => {
    console.error("[Nuxt vue:error Hook]", error)

    showError(error instanceof Error ? error : new Error(String(error)))
  })
})
